import React from 'react';
import Layout from '../../../components/Layout';
import FeaturedStripeComplete from '../../../components/FeaturedStripeComplete';

const title = 'Featured Payment Complete';

export default async function action({ store }) {
  // Note: Don't check authentication here - user may be redirected from Stripe
  // The component will handle verification of the payment intent
  return {
    title,
    component: <Layout><FeaturedStripeComplete title={title} /></Layout>,
  };
}
